// Author thq
// Date 2021-11-02 16:09:12

class EmCapitalSource {
constructor({
        id = null,
        sid = '',
        code = '',
        name = '',
        enablestate = '',
        remark = ''}
= {}) {
    this.id = id;
    this.sid = sid;
    this.code = code;
    this.name = name;
    this.enablestate = enablestate;
    this.remark = remark;
}
}

function newEntity() {
return new EmCapitalSource();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.archive.emCapitalSource.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sid',
        label: 'label.em.archive.emCapitalSource.grid.sid',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.em.archive.emCapitalSource.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.archive.emCapitalSource.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'enablestate',
        label: 'label.em.archive.emCapitalSource.grid.enablestate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emCapitalSource.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    sidFilter : '',
    codeFilter : '',
    nameFilter : '',
    enablestateFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'sidFilter',
        label: 'label.em.archive.emCapitalSource.filter.sid',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.em.archive.emCapitalSource.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.archive.emCapitalSource.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'enablestateFilter',
        label: 'label.em.archive.emCapitalSource.filter.enablestate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'sid',
        label: 'label.em.archive.emCapitalSource.entity.sid',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'code',
        label: 'label.em.archive.emCapitalSource.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'name',
        label: 'label.em.archive.emCapitalSource.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'enablestate',
        label: 'label.em.archive.emCapitalSource.entity.enablestate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emCapitalSource.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmCapitalSource, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
